import { render } from "./OverviewRowContainer.vue?vue&type=template&id=01bedcf5&scoped=true"
import script from "./OverviewRowContainer.vue?vue&type=script&lang=js"
export * from "./OverviewRowContainer.vue?vue&type=script&lang=js"

import "./OverviewRowContainer.vue?vue&type=style&index=0&id=01bedcf5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bedcf5"]])

export default __exports__